import { Link } from "react-router-dom";
import "./setting.css";
import { NewSidebareCommercial } from "../../NewSideBareCommercial";

export default function ChnageMailCommercial() {
  const handleGoBack = () => window.history.back();

  return (
    <>
      <NewSidebareCommercial />
      <div className="setting-page-wrapper">
        <div className="setting-page-inner">
          {/* Back */}
          <button className="setting-back-btn" onClick={handleGoBack}>
            <i className="bi bi-arrow-left"></i> Retour
          </button>

          {/* Form Card */}
          <div className="setting-form-card">
            <h2 className="setting-form-title">
              <i className="bi bi-envelope"></i>
              Changer l'adresse email
            </h2>
            <p className="setting-form-subtitle">
              Mettez à jour votre adresse email en saisissant les informations ci-dessous
            </p>

            <div className="setting-form-row">
              <div className="setting-form-group">
                <label className="setting-form-label">Email actuel</label>
                <input
                  type="email"
                  className="setting-form-input"
                  placeholder="Votre email actuel"
                />
              </div>

              <div className="setting-form-group">
                <label className="setting-form-label">Mot de passe</label>
                <input
                  type="password"
                  className="setting-form-input"
                  placeholder="Votre mot de passe"
                />
              </div>
            </div>

            <div className="setting-form-group">
              <label className="setting-form-label">Nouvel email</label>
              <input
                type="email"
                className="setting-form-input"
                placeholder="Entrez le nouvel email"
              />
            </div>

            <Link to="" className="setting-form-submit">
              <i className="bi bi-check2-circle"></i> Valider
            </Link>

            <Link to="" className="setting-form-alt-link">
              Contactez-nous
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}